module.exports = __webpack_public_path__ + "static/media/actuals.191da4e6.svg";